import React, { useContext, useEffect, useState} from "react";
import SavedProductContext from "../SavedProductsContext";
import { removeProducts } from "../utils/SavedProductsLocal";

import {  Button, HStack, Text } from "@chakra-ui/react";

export const BottomMenu = () => {
  const [products, setProducts, productsQty, setProductsQty] = useContext(
    SavedProductContext
  );
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let totalAux = 0;
    let keys = Object.keys(products);
    for(let i = 0; i < keys.length; i++){
      let productId = keys[i];
      totalAux += products[productId].salePrice * productsQty[productId];
    }
    setTotal(totalAux);
  }, [products, productsQty]);

  const resetProducts = () => {
    setProducts({});
    setProductsQty({});
    removeProducts();
    setTotal(0);
  };

  return (
    <HStack>
      <Text>Precio total: ${total}</Text>
      <Button onClick={resetProducts}>Resetear</Button>
    </HStack>
  );
};
